// extracted by mini-css-extract-plugin
module.exports = {"upload":"_36FtZJczaThO5_xhn2VvyO"};